import log from 'chameleon/ui-stack/utilities/log';

export default function loadEditor(type) {
  if (!type) {
    throw new Error(`${type} is required`);
  }
  const paths = [
    type,
    `${type.split('/').slice(0, -1).join('/')}/default`,
    'default',
  ];

  // eslint-disable-next-line no-unused-vars
  for (const path of paths) {
    try {
      return require(`./types/${path}`).default;
    } catch (e) {
      if (!e.message.startsWith('Cannot find module')) {
        throw e;
      }
      log('error', 'Load Editor Error', e);
    }
  }
  throw new Error(
    `Can't find editor for ${type}. Tried ${JSON.stringify(paths)}.`,
  );
}
